import { useEffect, useState } from "react";
import { adminFetch } from "./adminApi";

export default function AdminLogs() {
  const [items, setItems] = useState([]);
  const [note, setNote] = useState("");
  const [q, setQ] = useState("");
  const [loading, setLoading] = useState(true);

  async function load() {
    setLoading(true);
    const qs = new URLSearchParams();
    if (q.trim()) qs.set("q", q.trim());
    try {
      const data = await adminFetch(`/api/admin/logs/errors?${qs.toString()}`);
      setItems(Array.isArray(data?.items) ? data.items : []);
      setNote(data?.note || "");
    } catch (e) {
      setItems([]);
      setNote(e?.message || "Failed to load logs");
    } finally {
      setLoading(false);
    }
  }

  useEffect(() => {
    load();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className="text-white">
      <div className="flex items-end justify-between gap-3 flex-wrap">
        <div>
          <h2 className="font-unbounded text-2xl font-bold">Logs</h2>
          <p className="mt-2 text-white/70">Last errors (if ApiErrorLog installed).</p>
        </div>

        <div className="flex gap-2">
          <input
            value={q}
            onChange={(e) => setQ(e.target.value)}
            placeholder="Search userId/requestId…"
            className="w-64 rounded-lg bg-white/10 px-3 py-2 text-sm outline-none ring-1 ring-white/10 focus:ring-white/30"
          />
          <button
            onClick={load}
            className="rounded-lg bg-white/10 px-3 py-2 text-sm hover:bg-white/15 ring-1 ring-white/10"
          >
            Search
          </button>
        </div>
      </div>

      {note && <div className="mt-4 text-xs text-white/60">{note}</div>}
      {loading && <div className="mt-4 text-sm text-white/70">Loading…</div>}

      <div className="mt-5 space-y-2">
        {items.map((l) => (
          <div key={l.id} className="rounded-xl bg-white/5 ring-1 ring-white/10 p-3">
            <div className="text-xs text-white/50">{new Date(l.createdAt).toLocaleString()}</div>
            <div className="mt-1 text-white/80">{l.message}</div>
            <div className="mt-2 text-xs text-white/50">
              userId: {l.userId || "—"} · requestId: {l.requestId || "—"} · path: {l.path || "—"} · status:{" "}
              {l.status || "—"}
            </div>
          </div>
        ))}

        {!loading && items.length === 0 && (
          <div className="text-sm text-white/60">No logs.</div>
        )}
      </div>
    </div>
  );
}
